import { Injectable } from '@angular/core';
import { BaseService } from '../alcance/services/_base.service';
import { PlantaoFormularioDBService } from '../database/plantao-formulario-db.service';

@Injectable({
  providedIn: 'root'
})
export class PlantaoFormularioService extends BaseService{   
    override classname: string = 'PlantaoFormularioService';
    public override route: string = 'plantao-formulario';
        
    public override database = new PlantaoFormularioDBService();
}
